import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchSubmissionById(id) {
  return axios.get(`${apiUrl.submission.GET.DETAIL}${id}/`);
}

export function submitDeepfakeDetection(data) {
  return axios.post(apiUrl.category.POST, data);
}

export function fetchSubmissions(url, params) {
  return axios.get(url, { params });
}

export function deleteSubmissions(ids) {
  return axios.delete(apiUrl.submission.DELETE, { data: { ids } });
}

export function fetchSubmissionDetails(url, { allow404 = false } = {}) {
  return axios.get(url, { allow404 });
}

export function initiateUpload(data, { signal } = {}) {
  return axios.post(apiUrl.submissionsUpload.POST, data, { signal });
}

export function completeUpload(submissionId, { signal } = {}) {
  return axios.post(apiUrl.submissionsUpload.COMPLETE.replace("{id}", submissionId), null, { signal });
}
